import { useShallow } from "zustand/react/shallow";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { pods } from "@/lib/constants";
import { useStoreSynced } from "@/lib/store-synced";
import { cn } from "@/lib/utils";

interface CrewAvatarsProps {
  className?: string;
}

export function CrewAvatars({ className }: CrewAvatarsProps) {
  const { clientSelf, clientStatuses } = useStoreSynced(
    useShallow((s) => ({
      clientSelf: s.clientSelf,
      clientStatuses: s.clientStatuses,
    })),
  );

  const isPodSynced = (podNumber: string) => podNumber in clientStatuses;

  return (
    <div
      className={cn(
        "flex flex-row items-center justify-between p-4",
        className,
      )}
    >
      {pods
        .filter((p) => p.enabled)
        .map(({ pod, avatar: avatarSrc }) => {
          const isSelf = clientSelf?.podNumber === pod;
          const synced = isPodSynced(pod);
          return (
            <div key={pod} className={cn(!(isSelf || synced) && "opacity-50")}>
              <Avatar
                className={cn("w-13 h-13", isSelf && "ring-2 ring-green-500")}
              >
                <AvatarImage src={avatarSrc} alt={`${pod}`} />
                <AvatarFallback>{pod}</AvatarFallback>
              </Avatar>
              <p className="text-xs mt-1 text-center">{pod}</p>
            </div>
          );
        })}
    </div>
  );
}
